<template>
    <div class="addtop">
        <text style="font-size: 20px;">发布商品</text>&nbsp;&nbsp;&nbsp; <text style="font-size: 14px;">当前类目
            {{ tanme[0] }}{{ tanme[1] == null ? '' : '/' + tanme[1] }}{{ tanme[2] == null ? '' : '/' + tanme[2]
            }} </text>
    </div>
    <div class="goodinfo">
        <div class="procedure">
            <div class="procedures" @click="huadong(1)">
                <div>基础信息</div>
                <div class="proceduresnub" v-if="basicInformation != 0">{{ basicInformation }}</div>
                <div v-else style="color: #C9C9C9;font-size: 12px;">已完成</div>
            </div>
            <div class="procedures" @click="huadong(2)">
                <div>销售信息</div>
                <div class="proceduresnub" v-if="salenub != 0">{{ salenub }}</div>
                <div v-else style="color: #C9C9C9;font-size: 12px;">已完成</div>
            </div>
            <div class="procedures" @click="huadong(3)">
                <div>图文描述</div>
                <div class="proceduresnub" v-if="Fileurl[0].length < 1">1</div>
                <div v-else style="color: #C9C9C9;font-size: 12px;">已完成</div>
            </div>

            <div class="procedures" @click="huadong(4)">
                <div> 物流信息</div>
                <div class="proceduresnub" v-if="stream != 0"> {{ stream }} </div>

                <div v-else style="color: #C9C9C9;font-size: 12px;">已完成</div>
            </div>
            <div class="procedures" @click="huadong(5)">
                <div>支付设置</div>
                <div class="proceduresnub" v-if="paymentnub != 0"> {{ paymentnub }} </div>
                <div v-else style="color: #C9C9C9;font-size: 12px;">已完成</div>
            </div>
            <div class="procedures" @click="huadong(6)">
                <div>售后服务</div>
                <div style="color: #C9C9C9;font-size: 12px;">已完成</div>
            </div>

        </div>
        <div class="goodinfos">
            <div class="goodinfosleft">

            </div>
            <form>
                <div class="goodinfosright">
                    <div class="basisinfo">
                        <div class="basistop">基础信息</div>
                        <div class="goodname">
                            商品名称: &nbsp;&nbsp;&nbsp;<input type="text" v-model="goodmessges.basicInformation.name"
                                placeholder="请输入商品名称，最多30个字（60个字符）">
                        </div>
                        <div class="zhuyi">标题中请勿使用制表符、换行符。若填入制表符、换行符，系统将自动替换成空格</div>
                        <div class="property">
                            <div>
                                商品属性:
                            </div>
                            <div class="propertys">
                                <div class="propertys1">
                                    商品品牌：&nbsp;
                                    <!-- <el-select v-model="goodmessges.basicInformation.brand"
                                        @change="pinpaichange" placeholder="请选择商品品牌" style="width: 240px">
                                        <el-option v-for="item in pipailist" :key="item.id" :label="item.brandName"
                                            :value="item.id" />
                                    </el-select> -->
                                    <el-autocomplete v-model="goodmessges.basicInformation.brandname"
                                        :fetch-suggestions="querySearch3" clearable class="inline-input w-50"
                                        placeholder="请选择" @select="handleSelect3" />
                                </div>
                                <div class="propertys1">

                                </div>

                            </div>
                        </div>
                    </div>


                    <div class="Sales">
                        <div class="Salest">销售信息</div>
                        <div class="stext"> 颜色/款式：
                            <text style="font-size: 12px;">请选择或直接输入主色，标准颜色可增加搜索/导购机会，还可填写颜色备注信息（偏深、偏亮等）！</text>
                        </div>
                        <div class="kuanshi">
                            <div class="colorchoose">

                                <div style="margin-right: 26px;width: 166px;">
                                    <el-autocomplete v-model="goodmessges.sale.CustomColorname"
                                        :fetch-suggestions="querySearch" clearable class="inline-input w-50"
                                        placeholder="请选择" @select="handleSelect" />
                                </div>
                                <div style="width: 306px;margin-right: 20px;">
                                    <!-- <input type="text" placeholder="自定义名称填写" v-model="item.Custom"> -->
                                    <el-cascader :options="combinedSpecValues" :props="props" collapse-tags
                                        @change="cascaderguige" collapse-tags-tooltip clearable />
                                </div>
                                <!-- <div style="width: 60px; color: #1890FF;font-size: 12px;">优先展示</div> -->
                            </div>
                        </div>
                        <div class="stext"> 销售规格：
                            <text style="font-size: 12px;">优先展示会影响买家进入商品时候优先看见该款型商品。(表格中的数据都为必填)</text>
                        </div>
                        <div class="stable">
                            <table>
                                <thead>
                                    <tr>
                                        <th>
                                            <div class="tatext" style="">
                                                筛选款型颜色
                                            </div>
                                        </th>
                                        <th>
                                            <div class="tatext" style="">
                                                规格图片
                                            </div>
                                        </th>
                                        <th>
                                            <div class="tatext" style="">
                                                <el-input v-model="shareholderPrice"
                                                    style="width: 100%;font-size: 10px;" placeholder="批量填写股东价"
                                                    @change="shareholderPricec" />
                                            </div>
                                        </th>
                                        <th>
                                            <div class="tatext" style="">
                                                <el-input v-model="flowerPricee" style="width: 100%;font-size: 10px;"
                                                    placeholder="批量填写助花价" @change="flowerPricees" />

                                            </div>
                                        </th>
                                        <th>
                                            <div class="tatext" style="">

                                                <el-input v-model="memberPricee" style="width: 100%;font-size: 10px;"
                                                    placeholder="批量填写会员价" @change="memberPricees" />
                                            </div>
                                        </th>
                                        <th>
                                            <div class="tatext" style="">


                                                <el-input v-model="skuIde" style="width: 100%;font-size: 10px;"
                                                    placeholder="批量填写SKU编号" @change="skuIdes" />
                                            </div>
                                        </th>
                                        <th>
                                            <div class="tatext" style="">
                                                填写商品条形码
                                            </div>
                                        </th>
                                        <th>
                                            <div class="tatext" style="">

                                                <el-input v-model="inventorye" style="width: 100%;font-size: 10px;"
                                                    placeholder="批量填写数量" @change="inventoryes" />
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>

                                    <tr v-for="(item, index) in  goodmessges.sale.CustomColor" :key="index">
                                        <td style="font-size: 12px;">

                                            {{ !hasEmptyKey.value && item.specValue.length < 1 ? '请选择颜色/款式' :
                item.specValue }} </td>
                                        <td style="font-size: 14px;color: #1890FF;">

                                            <div class="setupimg">
                                                <div class="seimg">
                                                    <input type="file" :id="'avatars' + index" name="avatar"
                                                        accept="image/png, image/jpeg" ref="inputRefs"
                                                        @change="tirggerFile($event, index, false)" />
                                                </div>
                                                <div class="jia" @click="openImg(false, index)"
                                                    v-if="item.standardDetailsImgURL.length < 1">
                                                    选择图片
                                                </div>
                                                <div class="images" v-if="item.standardDetailsImgURL != ''"
                                                    @click="openImg(false, index)">
                                                    <img style="width:100%;height: 100%;"
                                                        :src="item.standardDetailsImgURL" />
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <input
                                                :class="(item.shareholderPrice.length < 1 && !hasEmptyKey.value) ? 'inputs' : ''"
                                                type="text" v-model="item.shareholderPrice">
                                            <!-- {{  }} -->
                                        </td>
                                        <td>
                                            <input
                                                :class="(item.flowerPrice.length < 1 && !hasEmptyKey.value) ? 'inputs' : ''"
                                                type="text" v-model="item.flowerPrice">
                                            <!-- {{ item.huaprice }} -->
                                        </td>
                                        <td>
                                            <input
                                                :class="(item.memberPrice.length < 1 && !hasEmptyKey.value) ? 'inputs' : ''"
                                                type="text" v-model="item.memberPrice">
                                            <!-- {{ item.vipprice }} -->
                                        </td>
                                        <td>
                                            <input
                                                :class="(item.skuId.length < 1 && !hasEmptyKey.value) ? 'inputs' : ''"
                                                type="text" v-model="item.skuId">
                                            <!-- {{ item.quantity }} -->
                                        </td>
                                        <td>
                                            <input
                                                :class="(item.barCode.length < 1 && !hasEmptyKey.value) ? 'inputs' : ''"
                                                type="text" v-model="item.barCode">
                                            <!-- {{ item.barcode }} -->
                                        </td>
                                        <td>
                                            <input
                                                :class="(item.inventory.length < 1 && !hasEmptyKey.value) ? 'inputs' : ''"
                                                type="text" v-model="item.inventory">
                                            <!-- {{ item.number }} -->
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>


                        <div class="xiaobiao">
                            <form action="" method="get" class="form-example">
                                <div>一口价：<text style="font-size: 12px;">随优先展示商品进行展示。</text></div>
                                <div class="form-example">
                                    <div class="examplemoney">￥</div>
                                    <label for="name"> </label>
                                    <input type="number" name="name" id="name" required placeholder="0"
                                        style="padding-left: 30px;width: 438px;" v-model="goodmessges.sale.miaosha" />
                                </div>
                                <div class="form-example">
                                    <label for="email">总数量： </label>
                                    <input type="number" name="email" id="email" required placeholder="0"
                                        v-model="goodmessges.sale.zongnumber" />
                                </div>
                                <div class="form-example">
                                    <label for="email">商家编码： </label>
                                    <input type="email" name="email" id="email" required placeholder="请输入商家编码"
                                        v-model="goodmessges.sale.bianma" />
                                </div>
                                <div class="form-example">
                                    <label for="email">商品条形码： </label>
                                    <input type="email" name="email" id="email" required placeholder="请输入商品条形码"
                                        v-model="goodmessges.sale.tiaoma" />
                                </div>
                                <div class="form-example">
                                    <label for="email">计量单位： </label>
                                    <input type="email" name="email" id="email" required placeholder="请输入计量单位"
                                        v-model="goodmessges.sale.danwei" />
                                </div>
                                <div class="form-example">
                                    <label for="email">商品重量： </label>
                                    <input type="email" name="email" id="email" required placeholder="请输入商品重量"
                                        v-model="goodmessges.sale.zhongliang" />
                                </div>
                            </form>


                        </div>

                    </div>
                    <div class="tuwen">

                        <div class="tuwenS">图文描述</div>

                        <div class="tutext">商品图:&nbsp;&nbsp;&nbsp;建议尺寸：800*800像素，注：最大支持上传3M文件.，每个人最多500m的图片储存空间。
                        </div>
                        <div class="setupimgs">
                            <div class="setupimg">
                                <div class="seimg">
                                    <input type="file" :id="'avatar' + 0" name="avatar" accept="image/png, image/jpeg"
                                        ref="inputRef" @change="tirggerFile($event, 0, true)" />
                                </div>
                                <div class="jia">
                                    <el-icon :size="30" color="#409EFC">
                                        <Plus />
                                    </el-icon>
                                </div>
                                <div class="images" v-if="imgUrl[0] != ''" @click="openImg(true, 0)">
                                    <img style="width:100%;height: 100%;" :src="imgUrl[0]" />
                                </div>
                                <div class="tioajian">商品主图</div>
                            </div>
                            <div class="setupimg">
                                <div class="seimg">
                                    <input type="file" :id="'avatar' + 1" name="avatar" accept="image/png, image/jpeg"
                                        ref="inputRef" @change="tirggerFile($event, 1, true)" />
                                </div>
                                <div class="jia">
                                    <el-icon :size="30" color="#409EFC">
                                        <Plus />
                                    </el-icon>
                                </div>
                                <div class="images" v-if="imgUrl[1] != ''" @click="openImg(true, 1)">
                                    <img style="width:100%;" :src="imgUrl[1]" />
                                </div>
                            </div>
                            <div class="setupimg">
                                <div class="seimg">
                                    <input type="file" :id="'avatar' + 2" name="avatar" accept="image/png, image/jpeg"
                                        ref="inputRef" @change="tirggerFile($event, 2, true)" />
                                </div>
                                <div class="jia">
                                    <el-icon :size="30" color="#409EFC">
                                        <Plus />
                                    </el-icon>
                                </div>
                                <div class="images" v-if="imgUrl[2] != ''" @click="openImg(true, 2)">
                                    <img style="width:100%;" :src="imgUrl[2]" />
                                </div>
                            </div>
                            <div class="setupimg">
                                <div class="seimg">
                                    <input type="file" :id="'avatar' + 3" name="avatar" accept="image/png, image/jpeg"
                                        ref="inputRef" @change="tirggerFile($event, 3, true)" />
                                </div>
                                <div class="jia">
                                    <el-icon :size="30" color="#409EFC">
                                        <Plus />
                                    </el-icon>
                                </div>
                                <div class="images" v-if="imgUrl[3] != ''" @click="openImg(true, 3)">
                                    <img style="width:100%;" :src="imgUrl[3]" />
                                </div>
                            </div>
                            <div class="setupimg">
                                <div class="seimg">
                                    <input type="file" :id="'avatar' + 4" name="avatar" accept="image/png, image/jpeg"
                                        ref="inputRef" @change="tirggerFile($event, 4, true)" />
                                </div>
                                <div class="jia">
                                    <el-icon :size="30" color="#409EFC">
                                        <Plus />
                                    </el-icon>
                                </div>
                                <div class="images" v-if="imgUrl[4] != ''" @click="openImg(true, 4)">
                                    <img style="width:100%;" :src="imgUrl[4]" />
                                </div>
                                <div class="tioajian">商品白底图</div>

                            </div>
                            <div class="setupimg">
                                <div class="seimg">
                                    <input type="file" id="videoFile" name="videoFile" accept="video/*"
                                        ref="videoInputRef" @change="tirggerFile($event, 5, true)" />
                                </div>
                                <div class="jia">
                                    <el-icon :size="30" color="#409EFC">
                                        <Plus />
                                    </el-icon>
                                </div>
                                <div class="images" v-if="imgUrl[5] != ''" @click="openvodie">
                                    <video style="width:100%;height: 100%;" :src="imgUrl[5]" muted
                                        autoplay="false"></video>
                                </div>
                                <div class="tioajian">上传视频</div>
                            </div>
                        </div>
                        <div class="tuchaote">
                            <div>描述:&nbsp;&nbsp;&nbsp;&nbsp;</div>
                            <div style="border: 1px solid #ccc;width: 589px;min-height: 277px;">
                                <Toolbar style="border-bottom: 1px solid #ccc" :editor="editorRef"
                                    :defaultConfig="toolbarConfig" />
                                <Editor style="height: 245x; overflow-y: hidden;" v-model="valueHtml"
                                    :defaultConfig="editorConfig" @onCreated="handleCreated" />
                            </div>
                        </div>
                    </div>
                    <div class="wuliu">
                        <div class="wutop">
                            物流信息
                        </div>
                        <div class="wufangs">
                            <div>提取方式：</div>
                            <div>
                                <div class="fangs" style="margin-top: 0px;">
                                    <!-- <input type="checkbox" id="wuliu" name="wuliu" checked
                                        v-model="goodmessges.stream.song" /> -->
                                    <label for="wuliu">物流配送</label>
                                </div>
                                <div class="wumo">
                                    运费模版：&nbsp;

                                    <el-autocomplete v-model="goodmessges.stream.moban"
                                        :fetch-suggestions="querySearch2" clearable class="inline-input w-50"
                                        placeholder="请选择" @select="handleSelect2" />
                                </div>

                                <div class="fangs">


                                    <input type="radio" id="daodian2" value="1" v-model="goodmessges.stream.daodian"
                                        name="1"><label for="daodian2">到店服务</label> <br><br>
                                    <input type="radio" id="daodian" value="2" v-model="goodmessges.stream.daodian"
                                        name="1"><label for="daodian">上门服务</label>

                                </div>




                            </div>

                        </div>


                    </div>
                    <div class="zhifu">
                        <div class="zhiftop">支付设置</div>
                        <div class="zhixuan">
                            <div class="fangs">
                                <input type="checkbox" id="zhuhau" name="zhuhau" checked
                                    v-model="goodmessges.payment.zhuhau" />
                                <label for="zhuhau">支持助花支付</label>
                            </div>
                            <div class="fangs">
                                <input type="checkbox" id="memgbi" name="memgbi" checked
                                    v-model="goodmessges.payment.memgbi" />
                                <label for="memgbi">支持门币支付</label>
                            </div>
                            <div class="fangs">
                                <input type="checkbox" id="jifen" name="jifen" checked
                                    v-model="goodmessges.payment.jifen" />
                                <label for="jifen">积分支付（5%）</label>
                            </div>

                        </div>
                        <div class="zhiftop">优惠设置</div>
                        <div class="youxuan">
                            <div class="fangs">
                                <input type="checkbox" id="jieti" name="jieti" checked
                                    v-model="goodmessges.payment.jietitrue" />
                                <label for="jieti">阶梯打折</label>
                            </div>
                            <div class="fang" v-for="(item, index) in goodmessges.payment.jieti" :key="index">

                                <div class="mannumber">
                                    <div style="margin-left: 23px;">满足数量(件)： <input placeholder="请输入满足数量" type="number"
                                            min="0" v-model="item.isnumber"></div>
                                    <div style="margin-left: 23px;"> 打折&nbsp;&nbsp; <input placeholder="请输入打折"
                                            type="text" v-model="item.jian"></div>
                                    <div class="mancuo">
                                        <div style="cursor: pointer;" @click="mianjianadd">添加</div>
                                        <div style="cursor: pointer;" @click="removejian(index)" v-if="index != 0">删除
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="youxuan">
                            <div class="fangs">
                                <input type="checkbox" id="manjian" name="manjian" checked
                                    v-model="goodmessges.payment.manjiantrue" />
                                <label for="manjian">价格满减</label>
                            </div>
                            <div class="mannumber" v-for="(item, index) in goodmessges.payment.manjian" :key="index">
                                <div style="margin-left: 23px;">满足数量(元)： <input type="number" placeholder="请输入满足金额"
                                        min="0" v-model="item.isnumber"></div>
                                <div style="margin-left: 23px;"> 减&nbsp;&nbsp; <input type="number" min="0"
                                        placeholder="请输入满减金额" v-model="item.jian"></div>

                                <div class="mancuo">
                                    <div style="cursor: pointer;" @click="jiagenadd">添加</div>
                                    <div style="cursor: pointer;" @click="removejiage(index)" v-if="index != 0">
                                        删除</div>
                                </div>
                            </div>

                        </div>
                        <!-- <div class="youxuan">
                                    <div class="fangs">
                                        <input type="checkbox" id="xiangou" name="xiangou" checked
                                            v-model="goodmessges.payment.xiangou.istrue" />
                                        <label for="xiangou">每人限购</label>
                                    </div>
                                    <div class="mannumber">
                                        <div style="margin-left: 23px;">限制数量： <input type="number" min="0"
                                                v-model="goodmessges.payment.xiangou.isnumber" style="width: 399px;">
                                        </div>
                                        <div class="mancuo">
                                        </div>
                                    </div>

                                </div> -->
                        <!-- <div class="youxuan">
                                    <div class="fangs">

                                        <label for="wuliu">优惠限时</label>
                                    </div>
                                    <div class="mannumber">

                                        <div class="wumo" style="margin-left: 23px;">
                                            选择活动：&nbsp;<input id="type" type="text"
                                                v-model="goodmessges.payment.xianshi" list="huodong"
                                                placeholder="请填选择参与的优惠">
                                            <datalist id="huodong">
                                                <option>秒杀</option>
                                                <option>好物推荐</option>
                                            </datalist>
                                        </div>

                                        <div class="mancuo">
                                            <div>选择时段</div>

                                        </div>
                                    </div>
                                </div> -->
                        <div class="youxuant">（打折与满减系统默认参与优惠最多的方案，并不同时参与）</div>
                    </div>
                    <div class="Aftersale">
                        <div class="aftert">
                            售后服务
                        </div>
                        <div class="fangs">
                            <input type="checkbox" id="qitui" name="qitui" checked
                                v-model="goodmessges.shouhou.qitui" />
                            <label for="qitui">服务承诺：该类商品，可支持【七天退货】服务</label>
                        </div>
                        <div class="fangs">
                            <input type="checkbox" id="bao" name="bao" checked v-model="goodmessges.shouhou.bao" />
                            <label for="bao">保修服务</label>
                        </div>
                        <div class="fangs">
                            <input type="checkbox" id="baoyou" name="baoyou" checked
                                v-model="goodmessges.shouhou.baoyou" />
                            <label for="baoyou">退换货承诺包邮</label>
                        </div>
                        <div class="fabu">
                            发布状态:&nbsp;&nbsp;
                            <input type="radio" id="huey" name="drone" value="1" checked
                                v-model="goodmessges.shouhou.zhuangtai" /><label
                                for="huey">&nbsp;上架</label>&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="dewey" name="drone" value="0"
                                v-model="goodmessges.shouhou.zhuangtai" /><label for="dewey">&nbsp;仓库中</label>
                        </div>
                    </div>
                    <div style="height: 83px;"></div>
                </div>
            </form>
            <div class="over">
                <div class="overs">
                    <div class="baochun" @click="baochun(true)">
                        保存并预览
                    </div>
                    <div class="baochun" @click="productRelease">
                        发布商品
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router';
import api from '@/api/api';
import storeapi from '@/api/store'
import '@wangeditor/editor/dist/css/style.css' // 引入 css

import { onBeforeUnmount, ref, shallowRef, onMounted, reactive, onUnmounted, watch } from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex';
// import {} from 'vue-router';

const route = useRoute()
const editorRef = shallowRef()
const inputRef = ref(null);
const inputRefs = ref(null)
let imgUrl = ref(['', '', '', '', '', ''])
let nums = ref(0)
let aniTimer
let sTop
let isAnimating = false
const store = useStore();
const tanme = ref([])
const tid = ref([])
const pipailist = ref([])
let productGoods = []
// const 

let shareholderPrice = ref(null)
let flowerPricee = ref(null)
let memberPricee = ref(null)
let skuIde = ref(null)
let inventorye = ref(null)
const shareholderPricec = () => {
    console.log(shareholderPrice.value)
    for (let a = 0; a < goodmessges.sale.CustomColor.length; a++) {

        goodmessges.sale.CustomColor[a].shareholderPrice = shareholderPrice.value

    }
}
const flowerPricees = () => {
    for (let a = 0; a < goodmessges.sale.CustomColor.length; a++) {

        goodmessges.sale.CustomColor[a].flowerPrice = flowerPricee.value

    }
}
const memberPricees = () => {
    for (let a = 0; a < goodmessges.sale.CustomColor.length; a++) {

        goodmessges.sale.CustomColor[a].memberPrice = memberPricee.value

    }
}
const skuIdes = () => {
    for (let a = 0; a < goodmessges.sale.CustomColor.length; a++) {

        goodmessges.sale.CustomColor[a].skuId = skuIde.value

    }
}
const inventoryes = () => {
    for (let a = 0; a < goodmessges.sale.CustomColor.length; a++) {

        goodmessges.sale.CustomColor[a].inventory = inventorye.value

    }
}


onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
});
onMounted(() => {
    console.log('route.query', route.query)
    tanme.value = route.query.tanme
    tid.value = route.query.tid
    qunxain()
    storeBrand()
    productGoodsType()
    freightTemplate()
    window.addEventListener('scroll', handleScroll);
    setTimeout(() => {
        valueHtml.value = ''
    }, 1500)
    baochun(false)

})


let freighttlist = []
const freightTemplate = async () => {
    let data = {
        storeId: 77,
        pageSize: 999
    }
    const res = await api.freightTemplates(data)
    console.log('freightTemplate', res)
    if (res.success) {

        freighttlist = res.data.tlist.map(item => {
            return { ...item, value: item.templateName };
        });
    }
}
let pipailists = []
const storeBrand = async () => {
    const res = await api.storeBrand()
    console.log('storeBrand', res)
    pipailist.value = res.data.tlist
    pipailists = res.data.tlist.map(item => {
        return { ...item, value: item.brandName };
    });
}
const productGoodsType = async () => {
    const res = await api.productGoodsType()
    productGoods = res.data.map(item => {
        return { ...item, value: item.typeName };
    });
    console.log('productGoodsType', productGoods)


}

const querySearch = (queryString, cb) => {
    console.log(queryString)
    const results = queryString ? createFilter(queryString) : productGoods
    console.log(results)

    cb(results)
}
const querySearch3 = (queryString, cb) => {
    console.log(queryString)
    const results = queryString ? createFilter3(queryString) : pipailists
    console.log(results)

    cb(results)
}
const createFilter3 = (queryString) => {
    // let asc = []
    const asc = pipailists.filter(item => item.value.includes(queryString));
    console.log(asc)

    return asc
}
const createFilter = (queryString) => {
    // let asc = []
    const asc = productGoods.filter(item => item.value.includes(queryString));
    console.log(asc)

    return asc
}
const createFilter2 = (queryString) => {
    // let asc = []
    const asc = freighttlist.filter(item => item.value.includes(queryString));
    console.log(asc)

    return asc
}
const querySearch2 = (queryString, cb) => {

    // const results = freighttlist.value.map(item => {
    //     return { ...item, value: item.templateName };
    // });
    const results = queryString ? createFilter2(queryString) : freighttlist
    console.log(results)

    cb(results)
}

let goodsTypeId = ref(null)
const handleSelect = (item) => {
    console.log(item)
    productSpec(item.id)
    goodsTypeId.value = item.id
}
const handleSelect3 = (item) => {
    console.log(item)
    // productSpec(item.id)
    goodmessges.basicInformation.brand = item.id
    // goodsTypeId.value = item.id
}
const props = { multiple: true }

let combinedSpecValues = ref([])
const productSpec = async (goodsTypeId) => {
    let data = {
        goodsTypeId,
        storeId: 77,
        // pageCount: 1,
        // pageSize: 99
    }
    const res = await api.productSpec(data)
    console.log('productSpec', res.data)
    let productSpeclength = res.data.tlist.length
    let specValues = []

    for (let a = 0; a < res.data.tlist.length; a++) {
        specValues.push(res.data.tlist[a].specValues.split(','));
    }
    console.log('specValues', specValues)
    // let specValues1 = res.data.tlist[0].specValues.split(',');
    // let specValues2 = res.data.tlist[1].specValues.split(',');
    combinedSpecValues.value = generateSpecValues(specValues);
    console.log(combinedSpecValues.value);

    // console.log(specValues1, specValues2);
}
function generateSpecValues(specValues, level = 0) {
    return specValues[level].map(value => {
        let node = {
            value: value,
            label: value,
            children: []
        };

        if (level < specValues.length - 1) {
            node.children = generateSpecValues(specValues, level + 1);
        }


        return node;
    });
}

let freightTemplateId = ref(null)
const handleSelect2 = (item) => {
    console.log(item)
    freightTemplateId.value = item.id
}
let hasEmptyKey = ref(false)
const productRelease = async () => {
    // goodmessges.payment.manjiantrue
    // goodmessges.payment.jietitrue
    let discountType = []
    let preferentialSet = []
    if (goodmessges.payment.manjiantrue) {
        discountType.push(4)
        for (let a = 0; a < goodmessges.payment.manjian.length; a++) {
            // const element = array[a];
            let data = {
                "preferentialCondition": goodmessges.payment.manjian[a].isnumber,
                "preferentialDiscount": Number(goodmessges.payment.manjian[a].jian),
                "preferentialType": 2
            }
            preferentialSet.push(data)

        }
    }
    if (goodmessges.payment.jietitrue) {
        discountType.push(3)
        for (let a = 0; a < goodmessges.payment.jieti.length; a++) {
            // const element = array[a];
            let data = {
                "preferentialCondition": goodmessges.payment.jieti[a].isnumber,
                "preferentialDiscount": Number(goodmessges.payment.jieti[a].jian),
                "preferentialType": 1
            }
            preferentialSet.push(data)

        }
    }
    let serviceAssuranceAfterSale = []
    if (goodmessges.shouhou.qitui) {
        serviceAssuranceAfterSale.push(1)
    }
    if (goodmessges.shouhou.bao) {
        serviceAssuranceAfterSale.push(5)
    }
    if (goodmessges.shouhou.baoyou) {
        serviceAssuranceAfterSale.push(2)
    }
    let serviceAssurancePay = []

    if (goodmessges.payment.zhuhau) {
        serviceAssurancePay.push(3)
    }
    if (goodmessges.payment.memgbi) {
        serviceAssurancePay.push(4)
    }
    if (goodmessges.payment.jifen) {
        serviceAssurancePay.push(6)
    }
    let data = {
        "productType": 1,
        "productReleaseParameter": {
            "barCode": goodmessges.sale.tiaoma,  //true
            "brandId": goodmessges.basicInformation.brand, //true
            "carouselImg": Fileurl.value, //true
            "categoryIdArray": tid.value, //true
            // "costPrice": goodmessges.sale.miaosha, //true
            "detailDescribe": valueHtml.value,
            // "detailTitle": '',
            "discountType": discountType, //true
            // "factoryPrice": 0,
            // "flowerPrice": 0,
            "freightTemplateId": freightTemplateId.value,
            "goodsTypeId": goodsTypeId.value,
            "introduction": valueHtml.value,
            "label": "",
            "logisticsWay": [goodmessges.stream.daodian],
            "mdetails": valueHtml.value, //true
            // "newsProduct": 0,
            "pdetails": valueHtml.value, //true
            "preferentialSet": preferentialSet, //true
            "price": goodmessges.sale.miaosha, //true
            "productImg": [Fileurl.value[0]],//true
            "productName": goodmessges.basicInformation.name,//true
            "quantity": goodmessges.sale.zongnumber,//true
            // "recommend": 0,
            "serviceAssuranceAfterSale": serviceAssuranceAfterSale,
            "serviceAssurancePay": serviceAssurancePay,//true
            // "shareholder": 0,
            "sign": goodmessges.shouhou.zhuangtai,//true

            "standardsSet": goodmessges.sale.CustomColor,
            "storeId": 77, //true
            // "subtitle": "",
            "unit": goodmessges.sale.danwei,//true
            "videoUrl": Fileurl.value[5],
            "weight": goodmessges.sale.zhongliang
        }

    }
    console.log('提交时的原数据', goodmessges)

    console.log('提交时的数据', data)
    goodmessges.sale.CustomColor.forEach(target => {
        target.productMainImg = Fileurl.value[0];

        // 判断对象中是否存在空的键
        hasEmptyKey.value = Object.values(target).some(value => {
            if (typeof value === 'string') {
                return !value.trim();
            } else {
                return false; // 如果不是字符串，则不判断为空
            }
        });
    });

    console.log('对象中空的键', hasEmptyKey.value, Fileurl.value[0]);


    if (basicInformation.value != 0) {
        ElMessage({
            message: '请完善基础信息！',
            type: 'warning',
        })
    } else if (salenub.value != 0) {
        ElMessage({
            message: '请完善销售信息！',
            type: 'warning',
        })
    } else if (Fileurl.value[0].length < 1) {
        ElMessage({
            message: '商品图至少上传一张主图！',
            type: 'warning',
        })
    } else if (stream.value != 0) {
        ElMessage({
            message: '请填写运费模板！',
            type: 'warning',
        })
    } else if (paymentnub.value != 0) {
        ElMessage({
            message: '至少选择一种支付方式',
            type: 'warning',
        })
    } else if (hasEmptyKey.value) {
        ElMessage({
            message: '请完成销售规格中的数据',
            type: 'warning',
        })
    } else {
        const res = await api.productRelease(data)
        console.log(res)
        if (res.success) {
            ElMessage({
                message: '发布成功',
                type: 'success',
            })
        } else {
            ElMessage.error('发布失败！' + res.message)
        }
    }

}
const handleScroll = (event) => {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    // console.log(scrollTop, '滚动距离')
    gunlin(scrollTop)
}
const pinpaichange = (e) => {
    console.log('basicInformation.brand', e)
}
const gunlin = (y) => {
    const procedure = document.querySelector('.procedure')
    procedure.style.top = y + 'px'
}
const huadong = (num) => {
    // 页面当前滚动距离
    nums.value = num
    sTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    let ement
    // console.log('sTop', sTop)
    if (num == 1) {
        // 处理 num 为 1 的情况
        ement = document.querySelector('.basisinfo').getBoundingClientRect()
        movewind(sTop, ement.top)
    } else if (num == 2) {
        ement = document.querySelector('.Sales').getBoundingClientRect()
        movewind(sTop, ement.top)
    } else if (num == 3) {
        ement = document.querySelector('.tuwen').getBoundingClientRect()
        movewind(sTop, ement.top)
    } else if (num == 4) {
        ement = document.querySelector('.wuliu').getBoundingClientRect()
        movewind(sTop, ement.top)
    } else if (num == 5) {
        ement = document.querySelector('.zhifu').getBoundingClientRect()
        movewind(sTop, ement.top)
    } else if (num == 6) {
        ement = document.querySelector('.Aftersale').getBoundingClientRect();
        movewind(sTop, ement.top);
    }
}

const movewind = (sTop, ementtop) => {
    let juli = parseInt(sTop + ementtop)

    let addDis = (juli - sTop) / 5

    sTop += addDis
    // console.log(sTop)
    window.scrollTo(0, sTop)
    console.log(Math.abs(juli - sTop))

    const documentHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;
    const bottomOffset = 5; // Adjust this value as needed

    if (Math.abs(juli - sTop) <= bottomOffset || sTop + windowHeight >= documentHeight) {
        nums.value = 0
        window.cancelAnimationFrame(aniTimer)
        sTop = 0
        aniTimer = null
        isAnimating = false
    } else {
        aniTimer = window.requestAnimationFrame(() => huadong(nums.value))
    }
}
const tirggerFile = (event, nub, falss) => {
    console.log(event, nub, falss);
    let file = event.target.files[0];
    let url = "";
    var reader = new FileReader();
    if (falss) {
        if (file && nub != 5) {
            console.log(file)
            reader.readAsDataURL(file);
            reader.onload = function (e) {
                url = this.result.substring(this.result.indexOf(",") + 1);
                imgUrl.value[nub] = "data:image/png;base64," + url;
                console.log(imgUrl._value[nub])
                // that.$refs['imgimg'].setAttribute('src','data:image/png;base64,'+url);
                productFileUpload('productCarouselImg', event.target.files[0], nub)
            };
        } else {
            console.log(file)
            reader.readAsDataURL(file);
            reader.onload = function (e) {
                url = this.result.substring(this.result.indexOf(",") + 1);
                imgUrl.value[nub] = "data:video/mp4;base64," + url;
                console.log(imgUrl._value)
                productFileUpload('productCarouselImg', event.target.files[0], nub)

                // that.$refs['imgimg'].setAttribute('src','data:image/png;base64,'+url);
            };
        }
    } else {
        console.log(file)
        reader.readAsDataURL(file);
        reader.onload = function (e) {
            url = this.result.substring(this.result.indexOf(",") + 1);
            goodmessges.sale.CustomColor[nub].standardDetailsImgURL = "data:image/png;base64," + url;
            console.log(goodmessges.sale.CustomColor[nub].standardDetailsImgURL)
            // carouselImg
            // that.$refs['imgimg'].setAttribute('src','data:image/png;base64,'+url);
            guigeUpload('productSpecImg', event.target.files[0], nub)
        };
    }


}
const Fileurl = ref(['', '', '', '', '', ''])
const productFileUpload = async (scopeType, files, nub) => {
    const formData = new FormData();
    formData.append('scopeType', scopeType);
    formData.append('files', files);
    const res = await api.productFileUpload(formData)
    console.log('productFileUpload', res)
    if (res.success) {
        Fileurl.value[nub] = res.data[0].data
        console.log('productFileUpload', Fileurl.value[nub])

    }
}
const guigeUpload = async (scopeType, files, nub) => {
    const formData = new FormData();
    formData.append('scopeType', scopeType);
    formData.append('files', files);
    const res = await api.productFileUpload(formData)
    console.log('productFileUpload', res)
    if (res.success) {
        goodmessges.sale.CustomColor[nub].standardDetailsImgURL = res.data[0].data
        goodmessges.sale.CustomColor[nub].carouselImg = res.data[0].data
    }
}
const openvodie = () => {
    document.getElementById('videoFile').click();

}
const openImg = (falss, index) => {
    if (falss) {
        document.getElementById('avatar' + index).click();
    } else {
        document.getElementById('avatars' + index).click();
    }
}

// 内容 HTML
const valueHtml = ref(null)

// 模拟 ajax 异步获取内容

let admins = ref()
const qunxain = () => {
    let adminPermList
    let adminPermLists
    let admin
    if (localStorage.getItem('usermassage') && JSON.parse(localStorage.getItem('usermassage')).adminPermList != null) {
        adminPermList = JSON.parse(localStorage.getItem('usermassage'))
        adminPermLists = adminPermList.adminPermList
        console.log('adminPermList', adminPermLists)
        admin = adminPermLists.filter(item => item.permPathLevel == 1 && item.permName != "管理账号" && item.permName != "后台设置")
        console.log('qunxain', admin)
        admins.value = admin
    }
}



const baochun = async (chun) => {
    let data = {
        operationAim: chun,
        productType: 1
    }

    if (chun) {
        goodmessges.goodsimg.image1 = Fileurl.value[0]
        goodmessges.goodsimg.image2 = Fileurl.value[1]
        goodmessges.goodsimg.image3 = Fileurl.value[2]
        goodmessges.goodsimg.image4 = Fileurl.value[3]
        goodmessges.goodsimg.bgc = Fileurl.value[4]
        goodmessges.goodsimg.goodsvideo = Fileurl.value[5]

        goodmessges.goodsimg.mioashu = valueHtml.value
        console.log('goodmessges', goodmessges)

        const res = await api.goodsTemporarilySave(goodmessges, data)
        console.log('baochun', res)
        if (res.success) {
            ElMessage({
                message: '保存成功',
                type: 'success',
            })
        } else {
            ElMessage.error(res.message)
        }
    } else {
        const res = await api.goodsTemporarilySave('', data)
        console.log('baochun', res.data.obj)
        if (res.data.obj) {
            goodmessges.basicInformation = res.data.obj.basicInformation
            goodmessges.goodsimg = res.data.obj.goodsimg
            goodmessges.payment = res.data.obj.payment
            goodmessges.sale = res.data.obj.sale
            goodmessges.shouhou = res.data.obj.shouhou
            goodmessges.stream = res.data.obj.stream
            // goodmessges = res.data.obj 
            imgUrl.value[0] = res.data.obj.goodsimg.image1
            imgUrl.value[1] = res.data.obj.goodsimg.image2
            imgUrl.value[2] = res.data.obj.goodsimg.image3
            imgUrl.value[3] = res.data.obj.goodsimg.image4
            imgUrl.value[4] = res.data.obj.goodsimg.bgc
            imgUrl.value[5] = res.data.obj.goodsimg.goodsvideo
            Fileurl.value[0] = res.data.obj.goodsimg.image1
            Fileurl.value[1] = res.data.obj.goodsimg.image2
            Fileurl.value[2] = res.data.obj.goodsimg.image3
            Fileurl.value[3] = res.data.obj.goodsimg.image4
            Fileurl.value[4] = res.data.obj.goodsimg.bgc
            Fileurl.value[5] = res.data.obj.goodsimg.goodsvideo
            valueHtml.value = res.data.obj.goodsimg.mioashu
            console.log('goodmessges', goodmessges)
            goodmessgesch(goodmessges)
        }


    }
}

const mianjianadd = () => {
    let data = {

        isnumber: '',
        jian: ''
    }
    goodmessges.payment.jieti.push(data)
}
const removejian = (index) => {
    goodmessges.payment.jieti.splice(index, 1)
}
const jiagenadd = () => {
    let data = {
        isnumber: '',
        jian: ''
    }
    goodmessges.payment.manjian.push(data)
}
const removejiage = (index) => {
    goodmessges.payment.manjian.splice(index, 1)

}
const cascaderguige = (e) => {
    console.log(e)
    let CustomColor = e

    let CustomColors = []
    for (let a = 0; a < CustomColor.length; a++) {
        let data = {
            specKey: '规格',
            specValue: '',
            standardName: '',
            standardDetails: '',
            standardDetailsImgURL: '',
            shareholderPrice: '',
            flowerPrice: '',
            memberPrice: '',
            skuId: '',
            barCode: '',
            inventory: '',
            productMainImg: Fileurl.value[0],
            standardProductType: 1,
            carouselImg: ''
        }
        data.specValue = CustomColor[a].join(' ');
        data.standardDetails = valueHtml.value;
        data.standardName = CustomColor[a].join(' ');
        CustomColors.push(data)
        console.log(CustomColors)

    }
    goodmessges.sale.CustomColor = CustomColors

}
let goodmessges = reactive({
    basicInformation: {
        name: '',
        brand: '',
        brandname: '',
        district: ''
    },
    sale: {
        CustomColorname: '',
        CustomColor: [
            {
                specKey: '规格',
                specValue: '',
                productMainImg: '',
                standardDetails: '',
                standardDetailsImgURL: '',
                shareholderPrice: '',
                flowerPrice: '',
                memberPrice: '',
                skuId: '',
                barCode: '',
                inventory: ''

            }
        ],
        miaosha: '',
        zongnumber: '',
        bianma: '',
        tiaoma: '',
        danwei: '',
        zhongliang: ''
    },
    goodsimg: {
        image1: Fileurl.value[0],
        image2: Fileurl.value[1],
        image3: Fileurl.value[2],
        image4: Fileurl.value[3],
        bgc: Fileurl.value[4],
        goodsvideo: Fileurl.value[5],
        mioashu: valueHtml.value
    },
    stream: {
        song: true,
        moban: '',
        daodian: '',

    },
    payment: {
        zhuhau: false,
        memgbi: false,
        jifen: false,
        jietitrue: false,
        jieti: [{

            isnumber: '',
            jian: ''
        }
        ],
        manjiantrue: false,

        manjian: [{

            isnumber: '',
            jian: ''
        }],
        xiangou: {
            istrue: false,
            isnumber: ''
        },
        xianshi: ''

    },
    shouhou: {
        qitui: false,
        bao: false,
        baoyou: false,
        zhuangtai: ''
    }
})
let basicInformation = ref(2)
let salenub = ref(7)
let stream = ref(1)
let paymentnub = ref(1)
watch(() => goodmessges, (newValue, oldValue) => {
    console.log('goodmessges 发生变化', newValue, oldValue);

    let emptyStrings = Object.values(newValue.basicInformation).filter(value => value === '');

    basicInformation.value = emptyStrings.length - 1
    let emptyStrings2 = Object.values(newValue.sale).filter(value => value === '');
    // console.log('goodmessges 发生变化', emptyStrings2);
    salenub.value = emptyStrings2.length
    let emptyStrings3 = Object.values(newValue.stream).filter(value => value === '');
    stream.value = emptyStrings3.length
    // let emptyStrings4 
    // newValue.payment.zhuhau ||  memgbi || jifen
    if (newValue.payment.zhuhau || newValue.payment.memgbi || newValue.payment.jifen) {
        paymentnub.value = 0
    }

}, { deep: true, immediate: true });
let valueHtmlchange = 0
watch(() => valueHtml.value, (newValue, oldValue) => {
    console.log('valueHtml 发生变化', newValue, oldValue);
    valueHtmlchange++
    if (valueHtmlchange > 10) {
        // console.log('进行违禁词处理');
        pageFbword(newValue)
        valueHtmlchange = 0

    }


}, { deep: true, immediate: true })

const pageFbword = async (keyword) => {

    let data = {
        "keyword": keyword,
        "keywordType": 0,
        "page": {
            "current": 1,
            "pageSize": 9999
        }
    }
    const res = await storeapi.pageFbword(data)

    console.log(res)
    const arrs = res.data.records.map(record => record.word);
    console.log('arrs关键字', arrs)
    valueHtml.value = replace(arrs, keyword, '*')


    console.log('替换后的文字', valueHtml.value)

}
/*
     * @sensitiveWordsArray {Array} sensitiveWordsArray 遍历敏感词库
     * @param {String} str 检测的字符
     * @param {String} char 替换的字符
     * @return {String} 替换后的文字
 */
function replace(sensitiveWordsArray, str, char) {
    //str: 需要进行替换的字符串
    //char: 需要替换的字符
    //遍历敏感词库
    for (let i = 0; i < sensitiveWordsArray.length; i++) {
        for (let j = 0; j <= str.length - sensitiveWordsArray[i].length; j++) {
            //根据敏感字符个数截取str的字符进行判断
            if (sensitiveWordsArray[i] == str.slice(j, j + sensitiveWordsArray[i].length)) {
                let c = "";
                for (let k = 0; k < sensitiveWordsArray[i].length; k++) {
                    c += char;
                }
                str = str.slice(0, j) + c + str.slice(j + sensitiveWordsArray[i].length);
            }
        }
    }
    return str;
}
const toolbarConfig = {}
const goodmessgesch = (newValue) => {
    let emptyStrings = Object.values(newValue.basicInformation).filter(value => value === '');

    basicInformation.value = emptyStrings.length - 1
    let emptyStrings2 = Object.values(newValue.sale).filter(value => value === '');
    // console.log('goodmessges 发生变化', emptyStrings2);
    salenub.value = emptyStrings2.length
    let emptyStrings3 = Object.values(newValue.stream).filter(value => value === '');
    stream.value = emptyStrings3.length
    // let emptyStrings4 
    // newValue.payment.zhuhau ||  memgbi || jifen
    if (newValue.payment.zhuhau || newValue.payment.memgbi || newValue.payment.jifen) {
        paymentnub.value = 0
    }
}
// const 

toolbarConfig.excludeKeys = [
    'headerSelect',
    'italic',
    'fontSize',
    'fontFamily',
    'lineHeight',
    'group-more-style',
    'fullScreen',
    'undo',
    'redo',
    'divider',
    'emotion',
    'insertLink',
    'group-video',
    'insertTable',
    'codeBlock',
    'blockquote',
    'todo',
    'bgColor',
    // 'group-image'


]
let xiangqingimg = ref([])
let baseURL = process.env.NODE_ENV === "development" ? "/api/commodity/productFileUpload" : "http://120.31.134.56:7878/commodity/productFileUpload" // 设置你的API基础URL
const token = localStorage.getItem('token');
const editorConfig = {
    placeholder: '请输入内容...',


    MENU_CONF: {
        uploadImage: {
            server: baseURL,
            headers: { X_access_token: token },
            maxNumberOfFiles: 1,
            fieldName: "files",
            meta: {
                scopeType: 'productDetailImg'
            },

            customInsert(res, insertFn) {
                if (res.code == 200) {

                    // xiangqingimg.value.push(res.data[0].data)

                    // let a = '<img src='+res.data[0].data+'>'
                    // let b = valueHtml.value
                    // // valueHtml.value =+ '<img src='+res.data[0].data+'>';
                    // valueHtml.value = b+a
                    console.log(res, insertFn);
                    insertFn(res.data[0].data, null, null)
                    console.log(valueHtml.value)
                }
            },
        },
    },



}

// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
    const editor = editorRef.value
    if (editor == null) return
    editor.destroy()
})

const handleCreated = (editor) => {
    editorRef.value = editor // 记录 editor 实例，重要！
}


</script>

<style lang="scss" scoped>
ol,
ul {
    list-style: none;
}

input {
    outline: none;
    border: 1px solid #D9D9D9;
    height: 32px;
    padding-left: 12px;
    font-size: 14px;
    vertical-align: middle;
}

label {
    vertical-align: middle;
    font-size: 14px;
    margin-left: 5px;

}

.addtop {
    color: rgba(0, 0, 0, 0.85);
    width: 100%;
    height: 48px;
    background: #FFFFFF;
    box-shadow: 0px 3px 29px 0px rgba(196, 203, 214, 0.1);
    border-radius: 8px;
    margin-bottom: 12px;
    line-height: 48px;
    padding-left: 22px;
    box-sizing: border-box;
}

.goodinfo {
    width: 100%;
    background: #FFFFFF;
    border-radius: 8px;
    position: relative;

    .procedure {
        // display: none;
        position: absolute;
        background-color: #fff;
        top: 20px;

        .procedures {
            width: 236px;
            height: 40px;
            line-height: 40px;
            display: flex;
            align-items: center;
            padding: 0 13px 0 32px;
            box-sizing: border-box;
            justify-content: space-between;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.65);
            cursor: pointer;

            .proceduresnub {
                width: 19px;
                height: 19px;
                border-radius: 10px;
                background: #E45B00;
                text-align: center;
                line-height: 19px;
                font-size: 13px;
                color: #FFFFFF;
            }


            // background: #E7F7FF;
        }

        .procedures:hover {
            background-color: #f1f1f1;
        }
    }

    .goodinfos {
        display: flex;

        .goodinfosleft {
            width: 236px;
            height: 100%;
            background-color: #fff;
        }

        .goodinfosright {
            width: calc(100%);
            background-color: #fff;

            .basisinfo {
                width: 100%;

                border-bottom: 1px solid #eaeaea;
                box-sizing: border-box;
                color: #666666;


                .basistop {
                    font-size: 14px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    color: #2A2A2A;
                    margin: 22px 0 0 37px;
                }

                .goodname {
                    color: #666666;
                    margin: 16px 0 0 54px;
                    font-size: 14px;


                    input {
                        outline: none;
                        border: 1px solid #D9D9D9;
                        width: 762px;
                        height: 32px;
                        padding-left: 12px;
                        font-size: 14px;

                    }

                }

                .zhuyi {
                    font-size: 12px;
                    font-weight: 400;
                    color: #C1C1C1;
                    margin: 7px 0 0 140px;
                }

                .property {
                    margin: 32px 0 38px 54px;
                    font-size: 14px;

                    .propertys {
                        width: 831px;
                        height: 79px;
                        margin-top: 16px;
                        background: #F7F7F7;
                        border: 1px solid rgba(112, 112, 112, 0.1);
                        display: flex;
                        align-items: center;
                        padding-left: 21px;

                        .propertys1 {
                            margin-right: 30px;

                            input {
                                width: 125px;
                            }

                            select {
                                width: 173px;
                                color: #C1C1C1;
                                font-size: 11px;
                            }
                        }


                    }


                }
            }



            .Sales {
                transition: transform 0.3s ease-in-out;
                color: #666666;

                .Salest {
                    margin: 28px 0 0 37px;
                    font-size: 14px;
                    font-weight: 600;

                    line-height: 20px
                }

                .stext {
                    margin: 19px 0 12px 40px;
                    font-size: 14px;
                }

                .kuanshi {
                    width: 500px;
                    margin: 0 24px 0 128px;

                    .colorchoose {
                        width: 100%;
                        display: flex;
                        align-items: center;

                    }

                }

                .stable {
                    margin: 7px 0 0 120px;

                    table {
                        border-collapse: collapse;

                        thead {



                            th {
                                padding: 7px;
                                border: 1px solid rgba(112, 112, 112, 0.16);

                                .tatext {
                                    width: 90px;
                                    height: 32px;
                                    // border: 1px solid #D9D9D9;
                                    font-size: 11px;
                                    line-height: 32px;

                                    input {
                                        padding: 0;
                                        width: 90px !important;
                                        font-size: 12px;

                                    }

                                }
                            }


                        }

                        tbody {
                            td {
                                width: 100px;
                                padding: 7px;
                                border-right: 1px solid rgba(112, 112, 112, 0.16);
                                box-sizing: border-box;

                                .setupimg {
                                    width: 80px;
                                    height: 30px;
                                    // background: #F2F3F5;
                                    position: relative;

                                    .images {
                                        position: absolute;
                                        top: 0;
                                        left: 0;
                                        width: 100%;
                                        height: 100%;
                                        overflow: hidden;
                                        // video{
                                        //     width: 100%;
                                        //     height: 100%;
                                        // }
                                    }

                                    .jia {
                                        position: absolute;
                                        cursor: pointer;
                                        width: 100%;
                                        top: 50%;
                                        left: 50%;
                                        transform: translate(-50%, -50%);
                                    }

                                    .seimg {

                                        width: 80px;
                                        height: 80px;

                                        input {
                                            padding: 0;
                                            width: 100%;
                                            height: 100%;
                                            opacity: 0;
                                            vertical-align: baseline;

                                        }

                                    }

                                    .tioajian {
                                        width: 80px;
                                        height: 23px;
                                        background: #8F8F8F;
                                        font-size: 11px;
                                        line-height: 23px;
                                        text-align: center;
                                        font-weight: 400;
                                        color: #FFFFFF;
                                    }
                                }

                                input {
                                    width: 70%;
                                }

                                .inputs {
                                    border: 1px solid red;
                                    border-radius: 4px;
                                }
                            }

                            :last-child {
                                border: none;

                            }
                        }
                    }
                }

                .xiaobiao {
                    margin: 52px 0 0 0;
                    font-size: 14px;
                    border-bottom: 1px solid #eaeaea;
                    padding-bottom: 25px;

                    input {
                        width: 456px;
                        height: 32px;

                    }

                    form {
                        margin-left: 123px;

                        .form-example {
                            position: relative;
                            margin-top: 17px;

                            .examplemoney {
                                position: absolute;
                                top: 8px;
                                left: 104px;
                            }

                            label {
                                display: inline-block;
                                width: 90px;
                                text-align: right;
                            }

                        }
                    }


                }

            }

            .tuwen {
                font-size: 13px;
                font-weight: 400;
                color: #666666;
                border-bottom: 1px solid #eaeaea;
                padding-bottom: 28px;

                .setupimgs {
                    display: flex;
                    justify-content: space-between;
                    margin: 4px 0 0 100px;
                    width: 600px;

                    .setupimg {
                        width: 80px;
                        height: 80px;
                        background: #F2F3F5;
                        position: relative;

                        .images {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            overflow: hidden;
                            // video{
                            //     width: 100%;
                            //     height: 100%;
                            // }
                        }

                        .jia {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                        }

                        .seimg {

                            width: 80px;
                            height: 80px;

                            input {
                                padding: 0;
                                width: 100%;
                                height: 100%;
                                opacity: 0;
                            }
                        }

                        .tioajian {
                            width: 80px;
                            height: 23px;
                            background: #8F8F8F;
                            font-size: 11px;
                            line-height: 23px;
                            text-align: center;
                            font-weight: 400;
                            color: #FFFFFF;
                        }
                    }
                }



                .tuwenS {
                    margin: 28px 0 0 37px;
                    font-size: 14px;
                    font-weight: 600;

                    line-height: 20px
                }

                .tutext {
                    margin: 25px 0 0 46px;
                }

                .tuchaote {
                    margin: 41px 0 0 54px;
                    display: flex;


                }

            }

            .wuliu {
                font-size: 14px;
                font-weight: 400;
                border-bottom: 1px solid #eaeaea;
                padding-bottom: 40px;

                .wutop {
                    margin: 28px 0 0 37px;
                    font-size: 14px;
                    font-weight: 600;
                    color: #2A2A2A;
                    line-height: 20px
                }

                .wufangs {
                    display: flex;
                    margin: 16px 0 0 37px;

                    .wumo {
                        width: 831px;
                        height: 79px;
                        color: #666666;
                        background: #F7F7F7;
                        border: 1px solid rgba(112, 112, 112, 0.10);
                        padding: 22px 0 0 23px;
                        margin-top: 17px;
                        box-sizing: border-box;

                        input {
                            width: 173px;
                        }
                    }

                    .fangs {
                        margin-top: 17px;

                        input {
                            width: 19px;
                            height: 19px;

                        }
                    }
                }

            }

            .zhifu {
                padding-bottom: 26px;
                border-bottom: 1px solid #eaeaea;


                .zhiftop {
                    font-size: 14px;
                    font-weight: 600;
                    color: #2A2A2A;
                    margin: 22px 0 0 34px;
                }

                .zhixuan {
                    margin-left: 100px;

                    .fangs {
                        margin-top: 17px;

                        input {
                            width: 19px;
                            height: 19px;

                        }
                    }
                }

                .youxuant {
                    margin: 11px 0 0 90px;
                    font-size: 12px;
                    font-weight: 400;
                    color: #666666;
                }

                .youxuan {
                    color: #666666;
                    margin: 23px 0 0 100px;

                    .fangs {
                        margin-top: 17px;

                        input {
                            width: 19px;
                            height: 19px;

                        }
                    }

                    .mannumber {

                        width: 831px;
                        height: 79px;
                        background: #F7F7F7;
                        border: 1px solid rgba(112, 112, 112, 0.10);
                        margin-top: 14px;
                        display: flex;
                        align-items: center;
                        font-size: 14px;
                        color: #666666;

                        input {
                            width: 173px;
                            background-color: #fff;
                        }


                        .mancuo {
                            div {
                                margin-left: 15px;

                            }

                            display: flex;
                            font-size: 12px;
                            font-weight: 400;
                            color: #1890FF;

                        }
                    }



                }
            }

            .Aftersale {
                .aftert {
                    font-size: 14px;
                    font-weight: 600;
                    color: #2A2A2A;
                    margin: 22px 0 0 34px;
                }

                .fangs {
                    margin: 20px 0 0 90px;

                    input {
                        width: 19px;
                        height: 19px;
                    }

                    label {
                        font-size: 14px;
                        font-weight: 400;
                        color: #666666;
                    }
                }

                .fabu {
                    font-size: 14px;
                    font-weight: 400;
                    color: #666666;
                    display: flex;
                    align-items: center;
                    margin: 23px 0 0 50px;

                    input {
                        width: 18px;
                        height: 18px;
                    }

                    label {
                        font-size: 14px;
                        font-weight: 400;
                        color: #666666;

                    }
                }

            }






        }

    }


}

.over {
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 61px;
    background: #FFFFFF;
    box-shadow: 0px -3px 6px 0px rgba(0, 0, 0, 0.16);
    display: flex;
    justify-content: center;
    align-items: center;


    .overs {
        display: flex;
        width: 356px;
        justify-content: space-between;

        .baochun {
            width: 148px;
            height: 48px;
            background: #444444;
            border-radius: 8px;
            color: #FFFFFF;
            line-height: 48px;
            text-align: center;
        }
    }



}
</style>